/**
 * The farm (tenant) the user is signed in to, read from the cached
 * `citrus_user` record. Used to stamp queued scouting rounds and to refuse to
 * upload a round recorded on a different farm.
 */

/** Returns the signed-in user's tenantId, or null when missing, empty or unreadable. */
export function getSignedInTenantId(): string | null {
  try {
    // A "Remember me" sign-in lives in localStorage; otherwise the user is
    // kept in sessionStorage for the session.
    const raw = localStorage.getItem('citrus_user') || sessionStorage.getItem('citrus_user');
    if (!raw) return null;
    const tenantId = JSON.parse(raw)?.tenantId;
    return typeof tenantId === 'string' && tenantId !== '' ? tenantId : null;
  } catch {
    return null;
  }
}
